import Typography from "@visa/vds/typography";
import React from "react";

function MCSReadonlyField(props) {
  return (
    <Typography className="vss-field-label">
      <b>{props.label}</b>&nbsp;&nbsp;&nbsp; {props.text}
    </Typography>
  );
}

export default MCSReadonlyField;
